import React, { useState } from 'react';
import './PreviewModal.css';

const PreviewModal = ({ blackCards, whiteCards, onClose }) => {
  const [currentBlackIndex, setCurrentBlackIndex] = useState(0);
  const [currentWhiteIndex, setCurrentWhiteIndex] = useState(0);

  const nextBlackCard = () => {
    setCurrentBlackIndex((prev) => (prev + 1) % blackCards.length);
  };

  const prevBlackCard = () => {
    setCurrentBlackIndex((prev) => (prev - 1 + blackCards.length) % blackCards.length);
  };

  const nextWhiteCard = () => {
    setCurrentWhiteIndex((prev) => (prev + 1) % whiteCards.length);
  };

  const prevWhiteCard = () => {
    setCurrentWhiteIndex((prev) => (prev - 1 + whiteCards.length) % whiteCards.length);
  };

  const handleOverlayClick = (e) => {
    if (e.target.className === 'preview-modal-overlay') {
      onClose();
    }
  };

  return (
    <div className="preview-modal-overlay" onClick={handleOverlayClick}>
      <div className="preview-modal-content">
        <div className="preview-modal-header">
          <h2>Deck Preview</h2>
          <button className="preview-close-btn" onClick={onClose} aria-label="Close preview">
            ✕
          </button>
        </div>

        <div className="preview-sections">
          {/* Question Cards Preview */}
          <div className="preview-section">
            <h3>Question Cards</h3>
            <p className="preview-counter">
              {currentBlackIndex + 1} of {blackCards.length}
            </p>

            {blackCards.length > 0 ? (
              <>
                <div className="preview-card-container">
                  <div className="preview-card preview-black-card">
                    <p>{blackCards[currentBlackIndex].text}</p>
                    <span className="preview-blanks-count">
                      {blackCards[currentBlackIndex].blanks} blank
                      {blackCards[currentBlackIndex].blanks !== 1 ? 's' : ''}
                    </span>
                  </div>
                </div>

                {blackCards.length > 1 && (
                  <div className="preview-navigation">
                    <button className="preview-nav-btn" onClick={prevBlackCard}>
                      ‹ Previous
                    </button>
                    <button className="preview-nav-btn" onClick={nextBlackCard}>
                      Next ›
                    </button>
                  </div>
                )}
              </>
            ) : (
              <p className="preview-empty">No question cards yet</p>
            )}
          </div>

          {/* Answer Cards Preview */}
          <div className="preview-section">
            <h3>Answer Cards</h3>
            <p className="preview-counter">
              {currentWhiteIndex + 1} of {whiteCards.length}
            </p>

            {whiteCards.length > 0 ? (
              <>
                <div className="preview-card-container">
                  <div className="preview-card preview-white-card">
                    <p>{whiteCards[currentWhiteIndex].text}</p>
                  </div>
                </div>

                {whiteCards.length > 1 && (
                  <div className="preview-navigation">
                    <button className="preview-nav-btn" onClick={prevWhiteCard}>
                      ‹ Previous
                    </button>
                    <button className="preview-nav-btn" onClick={nextWhiteCard}>
                      Next ›
                    </button>
                  </div>
                )}
              </>
            ) : (
              <p className="preview-empty">No answer cards yet</p>
            )}
          </div>
        </div>

        <div className="preview-modal-footer">
          <button className="btn-preview-close" onClick={onClose}>
            Close Preview
          </button>
        </div>
      </div>
    </div>
  );
};

export default PreviewModal;
